// extracted by mini-css-extract-plugin
export default {"Test":"Dropper_Test__EmpiN","Dots":"Dropper_Dots__Rr1zu","Dot":"Dropper_Dot__pLPFe","Options":"Dropper_Options__CDghE"};